import { createAction, props } from '@ngrx/store';
import { Currencies, PackDescriptionType } from '@cpak/enums';
import { AttributeTypeIds } from '@cpak/adp-cpak-products-service-models';
import { UserPreferencesState } from './user-preferences.models';
import { PlantsEnum } from '@cpak/adp-cpak-quotes-service-models';

export const setLanguage = createAction('[UserPreferences] set language', props<{ language: string }>());
export const setTimeZone = createAction('[UserPreferences] set time zone', props<{ timeZone: string }>());
export const setCurrency = createAction('[UserPreferences] set currency', props<{ currency: Currencies }>());
export const setPartNumberDisplay = createAction(
  '[UserPreferences] set part number display',
  props<{ partNumberDisplay: AttributeTypeIds }>()
);
export const setPackDescriptionDisplay = createAction(
  '[UserPreferences] set pack description display',
  props<{ packDescriptionDisplay: PackDescriptionType }>()
);
export const setShowInternalNotes = createAction(
  '[UserPreferences] set show internal notes',
  props<{ showInternalNotes: boolean }>()
);
export const setShowSpecialInstructions = createAction(
  '[UserPreferences] set show special instructions',
  props<{ showSpecialInstructions: boolean }>()
);
export const setReceiveEmailNotifications = createAction(
  '[UserPreferences] set receive email notifications',
  props<{ receiveEmailNotifications: boolean }>()
);
export const setDefaultConfig = createAction(
  '[UserPreferences] set default config',
  props<Partial<UserPreferencesState>>()
);

export const setPlant = createAction('[UserPreferences] set plant', props<{ plant: PlantsEnum }>());
